module.exports = __webpack_public_path__ + "static/media/canvas_fabric.aaf31cb3.svg";